import { ITooltipComp, ITooltipParams } from '@ag-grid-community/core';
import { getIconByName } from '../../styles';
import { ICON_COLORS, ICONS } from '../enums/generic.enum';
import { tooltipStyles } from '../../components/custom-styles/zero-tooltip';

export class IconLegendTooltipComponent implements ITooltipComp {
  init(params: ITooltipParams) {
    // Prevents the tooltip from popping up in the column sidebar
    if (params.location === 'header') {
      this.content = document.createElement('div');

      // Set Tooltip styles to match zero-tooltip styles to be consistent
      this.content.style.cssText = tooltipStyles;

      const legendTitle = document.createElement('span');
      legendTitle.innerHTML = 'Icon Legend';
      legendTitle.style.fontWeight = 'bold';
      legendTitle.style.textDecoration = 'underline';

      this.content.appendChild(legendTitle);
      this.content.appendChild(document.createElement('br'));

      this.getIconsForStatus(ICON_COLORS.NEW_BUILD_PROJECT_STATUS);
      this.getIconsForStatus(ICON_COLORS.POST_BUILD_PROJECT_STATUS);
      this.getIconsForStatus(ICON_COLORS.REC_STATUS);
    } else {
      this.content = document.createElement('div');
      this.content.style.display = 'none';
    }
  }

  content: HTMLElement;

  getGui(): HTMLElement {
    return this.content;
  }

  refresh(): boolean {
    return false;
  }

  /**
   * Helper Function for displaying the technology icons and Operational Status Text
   *
   * @param fillColor which color you want the icons to be - one of ICON_COLORS
   * @private
   */
  private getIconsForStatus(fillColor: ICON_COLORS) {
    const icons = document.createElement('span');
    icons.innerHTML = getIconByName(ICONS.WIND_TECHNOLOGY, 'start', null, null, fillColor);
    icons.innerHTML += '/';
    icons.innerHTML += getIconByName(ICONS.SOLAR_TECHNOLOGY, 'start', null, null, fillColor);
    const text = document.createElement('span');
    if (fillColor === ICON_COLORS.REC_STATUS) {
      text.innerHTML = 'REC';
    } else if (fillColor === ICON_COLORS.NEW_BUILD_PROJECT_STATUS) {
      text.innerHTML = 'New Build';
    } else if (fillColor === ICON_COLORS.POST_BUILD_PROJECT_STATUS) {
      text.innerHTML = 'Operational';
    }
    text.innerHTML += ' Wind or Solar';
    this.content.appendChild(document.createElement('br'));
    this.content.appendChild(icons);
    this.content.appendChild(text);
  }
}
